import styled from 'styled-components';

export const StyledUserInfoContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    z-index: 2;
`
export const StyledProfileIconWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 0.5rem;
    position: relative;
`

export const StyledProfileIcon= styled.img`
    border-radius: 100%;
    margin-right: 1rem;
    width: 60px;
    height: 60px;
    object-fit: cover;
`

export const StyledUserBalance = styled.h5`
    color: white;
    font-size: 12px;
    padding: 0 0.5rem;
    background-color: #416043;
    border-radius: 1.5rem;
    margin: 0;
`

export const StyledMenuWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #224317;
    border-radius: 5px;
    position: absolute;
    top: 80px;
    right: -40px;
    overflow: hidden;
    display: none;
    
    & h3 {
        font-size: 24px;
        padding: 20px;
        box-sizing: border-box;
        width: 100%;
    }

    & h3:hover {
        color: #E9F9DE;
        background-color: #416043;
    }
`

export const StyledMobileMenuFooterWrapper = styled.div`
    & h3 {
        font-size: 24px;
        box-sizing: border-box;
        width: 100%;
        color: white;
        cursor: pointer;
    }
`